
import Icon from '../../components/AppIcon';

const HeaderComponent = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Demo Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-foreground mb-4">
            مكون الهيدر
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            هيدر احترافي يحتوي على الشعار وأيقونة الملف الشخصي مع قائمة منسدلة تتكيف حسب نوع المستخدم (مصور أو عميل)
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
                <Icon name="Camera" size={24} color="var(--color-primary)" />
              </div>
              <h3 className="text-lg font-semibold">الشعار الاحترافي</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              شعار مشهد مع النقاط الثلاث الملونة والتصميم العربي الحديث
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-secondary/10">
                <Icon name="User" size={24} color="var(--color-secondary)" />
              </div>
              <h3 className="text-lg font-semibold">الملف الشخصي</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              أيقونة الملف الشخصي مع قائمة منسدلة تحتوي على لوحة التحكم والإعدادات
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-accent/10">
                <Icon name="LayoutDashboard" size={24} color="var(--color-accent)" />
              </div>
              <h3 className="text-lg font-semibold">لوحة التحكم</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              وصول سريع إلى لوحة التحكم والحجوزات والمدفوعات والإشعارات
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-success/10">
                <Icon name="Users" size={24} color="var(--color-success)" />
              </div>
              <h3 className="text-lg font-semibold">تكيف حسب المستخدم</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              القائمة تتغير تلقائياً حسب نوع المستخدم (مصور أو عميل)
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-warning/10">
                <Icon name="Smartphone" size={24} color="var(--color-warning)" />
              </div>
              <h3 className="text-lg font-semibold">متجاوب تماماً</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              تصميم متجاوب يعمل بشكل مثالي على جميع الأجهزة والشاشات
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-error/10">
                <Icon name="Languages" size={24} color="var(--color-error)" />
              </div>
              <h3 className="text-lg font-semibold">دعم RTL</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              دعم كامل للغة العربية مع تخطيط RTL وخط IBM Plex Sans Arabic
            </p>
          </div>
        </div>

        {/* Menu Items Preview */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Photographer Menu */}
          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
              <Icon name="Camera" size={24} color="var(--color-primary)" />
              قائمة المصور
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm">
                <Icon name="LayoutDashboard" size={18} color="var(--color-primary)" />
                <span>لوحة التحكم</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="Image" size={18} color="var(--color-primary)" />
                <span>إدارة المعرض</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="Calendar" size={18} color="var(--color-primary)" />
                <span>الحجوزات</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="DollarSign" size={18} color="var(--color-primary)" />
                <span>المدفوعات</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="Bell" size={18} color="var(--color-primary)" />
                <span>الإشعارات</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="User" size={18} color="var(--color-primary)" />
                <span>الملف الشخصي</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="Settings" size={18} color="var(--color-primary)" />
                <span>الإعدادات</span>
              </li>
            </ul>
          </div>

          {/* Customer Menu */}
          <div className="bg-white rounded-xl p-6 border border-border shadow-sm">
            <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
              <Icon name="User" size={24} color="var(--color-secondary)" />
              قائمة العميل
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm">
                <Icon name="LayoutDashboard" size={18} color="var(--color-secondary)" />
                <span>لوحة التحكم</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="Calendar" size={18} color="var(--color-secondary)" />
                <span>حجوزاتي</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="DollarSign" size={18} color="var(--color-secondary)" />
                <span>المدفوعات</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="Bell" size={18} color="var(--color-secondary)" />
                <span>الإشعارات</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="Heart" size={18} color="var(--color-secondary)" />
                <span>المفضلة</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="User" size={18} color="var(--color-secondary)" />
                <span>الملف الشخصي</span>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Icon name="Settings" size={18} color="var(--color-secondary)" />
                <span>الإعدادات</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderComponent;